module.exports = __webpack_public_path__ + "img/pbadel.0c148126.jpg";